import React from 'react';
import { EmailProvider } from 'nekst-api';

interface EmailSuccessStatusProps {
  provider?: EmailProvider | null;
}

export default function EmailSuccessStatus({ provider }: EmailSuccessStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case EmailProvider.GMAIL:
        return 'Gmail';
      default:
        return 'Email';
    }
  };

  return (
    <div>
      <i
        className="fa fa-check-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#28a745' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#28a745' }}>
        {getProviderName()} account connected successfully!
      </h2>
      <p style={{ color: '#666' }}>
        Your {getProviderName()} account is now connected for email sending. You're being redirected back to settings...
      </p>
    </div>
  );
}